import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { IconButton, Button } from '@mui/material';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useDispatch } from 'react-redux';
import { useSystemId } from "../../../hooks/useReduxSelectors";
import { fetchReportsWithTimeRange, resendReports } from '../../../ducks/reportsDuck';
import { useTranslation } from "react-i18next";

const Calendar = ({ reportName, energyReportType }) => {

  const systemId = useSystemId();
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const today = dayjs();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(today);
  let disableEndDateAndGetreports = !startDate;

  const buildReportArgs = () => {
    const startDateFormatted = startDate.format("YYYY-MM-DD");
    let endDateFormatted = endDate ? endDate.format("YYYY-MM-DD") : startDateFormatted;
    let args = {
      ReportName: reportName,
      QueryStartDate: startDateFormatted,
      QueryStopDate: endDateFormatted,
    };
    if (reportName === "EnergiesReport") {
      const energyReportNameForFetch = energyReportType === "Month" ? "MonthHeatMap" : "DayHeatMap";
      args = { ...args, ReportName: energyReportNameForFetch };
    }
    return args;
  };

  const getReportsWithTimeRange = () => {
    dispatch(fetchReportsWithTimeRange({ systemId, args: buildReportArgs() }));
  };

  const handleResendReports = () => {
    dispatch(resendReports({ systemId, args: buildReportArgs() }));
  };

  useEffect(() => {
    if (!startDate) {
      setEndDate(null);
    } else if (endDate && startDate.isAfter(endDate)) {
      setEndDate(null);
    }
    if (startDate && !endDate) {
      setEndDate(today);
    }
  }, [startDate]);

  const datePickerSlotProps = {
    textField: {
      size: "small",
      sx: { width: 155, mx: 0.25, "& .MuiInputBase-input": { color: "common.white" }, "& .MuiSvgIcon-root": { color: "common.white" } },
    },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={t("From")}
        value={startDate}
        onChange={(val) => setStartDate(val)}
        format="DD.MM.YYYY"
        maxDate={today}
        slotProps={datePickerSlotProps}
      />
      {startDate && (
        <IconButton size="small" onClick={() => setStartDate(null)} sx={{ color: "common.white" }}>
          <EventBusyIcon />
        </IconButton>
      )}
      <DatePicker
        label={endDate ? "" : today.format("DD.MM.YYYY")}
        value={endDate}
        onChange={(val) => setEndDate(val)}
        format="DD.MM.YYYY"
        minDate={startDate}
        maxDate={today}
        disabled={disableEndDateAndGetreports}
        slotProps={datePickerSlotProps}
      />
      {endDate && (
        <IconButton size="small" onClick={() => setEndDate(null)} sx={{ color: "common.white" }}>
          <EventBusyIcon />
        </IconButton>
      )}
      {disableEndDateAndGetreports ? (
        <Button disabled variant="contained" size="small" sx={{ mx: 0.5, whiteSpace: "nowrap" }}>
          {t("Select date first")}
        </Button>
      ) : (
        <>
          <Button variant="contained" color="success" size="small" sx={{ mx: 0.5, whiteSpace: "nowrap" }} onClick={getReportsWithTimeRange}>
            {t("Show by date")}
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleResendReports}
            sx={{
              mx: 0.5,
              whiteSpace: "nowrap",
              color: "orange",
              borderColor: "orange",
              borderWidth: 1,
              "&:hover": { borderColor: "orange", borderWidth: 1 },
            }}
          >
            {t("Resend")}
          </Button>
        </>
      )}
    </LocalizationProvider>
  );
};

export default Calendar;
